import axios from 'axios';
import { serverUrl } from '../config/env';
import { getToken } from '../utils/storage';
import Version from '../js/version/Version';

const api = axios.create({
  baseURL: serverUrl,
  timeout: 30000,
  headers: {
    'Content-type': 'application/json; charset=utf-8',
    'ClientType': Version.ClientType,
    'AppVersion': Version.AppVersion,
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    // Handle common errors here
    if (error.response?.status === 401) {
      // Unauthorized - token expired
      localStorage.removeItem('userDetailsAdmin');
      window.location.href = '/sign-in';
    }
    return Promise.reject(error);
  }
);

export default api;
